import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { ThemeService } from 'src/app/services/theme.service';
import { Application } from 'src/model/Application';
import * as _ from 'lodash';
import { SecurityService } from 'src/app/services/security.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  applications: Application[];
  searchText: string;
  selectedTheme: string;
  logoId: string;
  logoPath: string;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private themeService: ThemeService,
    private securityService: SecurityService
  ) { }

  async ngOnInit() {
    this.applications = await this.loginService.getUserApplications();
    const doesUserHavePermission = this.securityService.userHasPermission('manage_permission');

    if ( !doesUserHavePermission ) {
      this.applications = _.filter(this.applications, (o) => { return o.applicationName !== 'permissions' });
    }

    this.logoId = this.loginService.tokenClaims.logoId;
    this.logoPath = this.loginService.tokenClaims.logoPath;

    this.themeService.theme.subscribe((t) => {
      this.selectedTheme = t;
  });
  }

  getLogoPath(){
    if(this.logoId === "0"){
      if ( this.selectedTheme === 'dark' ) {
        return `/assets/layout/images/logos/dark/fmx-onsite-logo.png`;
      } else {
        return `/assets/layout/images/logos/light/fmx-onsite-logo.png`;
      }
    }else {
      return `/assets/layout/images/logos/${this.logoId}/${this.selectedTheme}/${this.logoPath}`;
    }
  }

  navigate(application: Application){
    this.router.navigate([application.route], {state: {application}});
  }
}
